export enum SyncOptions {
    LocalOnly = 'Local',
    ApplicationOnly = 'App',
    AllOutlooks = 'AllOutlooks',
}
